/**
 * @generated SignedSource<<825ab09b27b51a4519c34a5f65519c71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PageContentRenderer_content$data = {
  readonly appearancePublished: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly body: {
    readonly dynamic: {
      readonly content: {
        readonly id: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null;
      readonly representation: string | null;
      readonly value: string | null;
      readonly webresource: {
        readonly superbatch: {
          readonly tags: {
            readonly css: string | null;
            readonly js: string | null;
          } | null;
        } | null;
        readonly tags: {
          readonly css: string | null;
          readonly js: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly id: string | null;
  readonly metadata: {
    readonly lastModifiedDate: string | null;
  };
  readonly numberedHeadingsPublished?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly properties: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly status: string | null;
  readonly title: string | null;
  readonly type: string | null;
  readonly version: {
    readonly confRev: string | null;
    readonly number: number | null;
  } | null;
  readonly " $fragmentType": "PageContentRenderer_content";
};
export type PageContentRenderer_content$key = {
  readonly " $data"?: PageContentRenderer_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageContentRenderer_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "number"
},
v2 = {
  "kind": "ScalarField",
  "name": "value"
},
v3 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ]
},
v4 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "js"
    },
    {
      "kind": "ScalarField",
      "name": "css"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "includeNumberedHeadings"
    }
  ],
  "kind": "Fragment",
  "name": "PageContentRenderer_content",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "confRev"
        },
        (v1/*: any*/)
      ]
    },
    {
      "concreteType": "ContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lastModifiedDate"
        }
      ]
    },
    {
      "concreteType": "ContentBodyPerRepresentation",
      "kind": "LinkedField",
      "name": "body",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentBody",
          "kind": "LinkedField",
          "name": "dynamic",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "representation"
            },
            (v2/*: any*/),
            {
              "concreteType": "Content",
              "kind": "LinkedField",
              "name": "content",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/)
              ]
            },
            {
              "concreteType": "WebResourceDependencies",
              "kind": "LinkedField",
              "name": "webresource",
              "plural": false,
              "selections": [
                {
                  "concreteType": "SuperBatchWebResources",
                  "kind": "LinkedField",
                  "name": "superbatch",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/)
                  ]
                },
                (v4/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "alias": "appearancePublished",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "content-appearance-published"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": "properties(key:\"content-appearance-published\")"
    },
    {
      "condition": "includeNumberedHeadings",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "numberedHeadingsPublished",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "numbered-headings-published"
            }
          ],
          "concreteType": "PaginatedJsonContentPropertyList",
          "kind": "LinkedField",
          "name": "properties",
          "plural": false,
          "selections": [
            {
              "concreteType": "JsonContentProperty",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v5/*: any*/),
                (v2/*: any*/)
              ]
            }
          ],
          "storageKey": "properties(key:\"numbered-headings-published\")"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "keys",
          "value": [
            "cover-picture-id-published",
            "emoji-title-published",
            "editor",
            "import-source",
            "imported-page-modified-date"
          ]
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "ab35378bff27a9fcffaeb32b8a8186da";

export default node;
